// @flow
import { createLogger } from 'redux-logger';

// log actions in development mode
export default createLogger({
  collapsed: true,

  // only log in development mode
  // /* global __DEV__ */
  // predicate: () => __DEV__,

  // transform immutable state to plain objects
  // stateTransformer: state => state.toJS(),

  // transform immutable action payloads to plain objects
  // actionTransformer: (action) => {
  //   if (action && action.payload && action.payload.toJS) {
  //     return { ...action, payload: action.payload.toJS() };
  //   }
  //   return action;
  // },
});
